export type THeaders = {
  "Content-Type"?: TContentType;
  Authorization?: string;
  Host?: string;
  "Ocp-Apim-Subscription-Key"?: string;
};

type TContentType = "application/json" | "multipart/form-data" | string;

const jsonContentTypes = ["application/problem+json", "application/json"];

export type THTTPError = {
  status: number;
  statusText: string;
  errorObject?: Record<string, unknown>;
  errorText?: string;
};

export const postFetch = async (url: string, body: any, headers: THeaders = { "Content-Type": "application/json" }) => {
  const response = fetch(url, {
    method: "POST",
    body: body,
    headers: headers,
  });

  return response.then((res) => handleResponse(res));
};

export const getFetch = async (url: string, headers: THeaders = { "Content-Type": "application/json" }) => {
  const response = fetch(url, {
    method: "GET",
    headers: headers,
  });

  return response.then((res) => handleResponse(res));
};

export const deleteFetch = async (url: string, headers: THeaders = { "Content-Type": "application/json" }) => {
  const response = fetch(url, {
    method: "DELETE",
    headers: headers,
  });

  return response.then((res) => handleResponse(res));
};

const handleResponse = async (response: Response) => {
  if (response.status === 200) {
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") > -1) {
      return response.json();
    }
    return response.text();
  }

  let errorObject = undefined;
  let errorText = undefined;

  const contentType = response.headers.get("content-type");
  if (contentType && jsonContentTypes.includes(contentType)) {
    errorObject = await response.json();
  } else {
    errorText = await response.text();
  }

  const error: THTTPError = {
    status: response.status,
    statusText: response.statusText,
    errorObject: errorObject,
    errorText: errorText,
  };

  throw error;
};
